import * as React from "react";
import Grid from "@mui/material/Grid2";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useTranslation } from "react-i18next";
import SlotConfigGrid from "./SlotConfigGrid";
import SlotGrid from "./SlotGrid";
import StockGrid from "./StockGrid";
import NodeSlotGrid from "./NodeSlotGrid";
// import MiniDataGrid from ".//MiniDataGrid";
// import TopicHeaderr from "./TopicHeaderr";
// import ObjectDetails from "./ObjectDetails";

export default function StocksGrid() {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = React.useState(0);
  const [selectedConfig, setSelectedConfig] = React.useState(null);
  const [slotRefreshTrigger, setSlotRefreshTrigger] = React.useState(0);

  const handleTabChange = (_event, newValue) => {
    setTabValue(newValue);
  };

  const handleConfigSelect = (config) => {
    setSelectedConfig(config);
  };

  const handleSlotsRefresh = () => {
    setSlotRefreshTrigger((prev) => prev + 1);
  };

  return (
    <Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
      <Box
        sx={{
          borderBottom: 2,
          borderColor: "divider",
          mb: 3,
          bgcolor: "background.paper",
          borderRadius: "8px 8px 0 0",
          boxShadow: 1,
        }}
      >
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="stocks tabs"
          sx={{
            px: 2,
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 600,
              fontSize: "1rem",
              minHeight: 56,
              color: "text.secondary",
              transition: "all 0.3s ease",
              "&:hover": {
                color: "primary.main",
                bgcolor: "action.hover",
              },
              "&.Mui-selected": {
                color: "primary.main",
              },
            },
            "& .MuiTabs-indicator": {
              height: 3,
              borderRadius: "3px 3px 0 0",
            },
          }}
        >
          <Tab label={t("stocks.tabs.nodeSlots")} />
          <Tab label={t("stocks.tabs.slots")} />
          <Tab label={t("stocks.tabs.stocks")} />
        </Tabs>
      </Box>

      {tabValue === 0 && (
        <Grid container spacing={2} columns={12} alignItems="stretch">
          <Grid size={{ xs: 12, lg: 12 }}>
            <Paper elevation={2} sx={{ p: 2, height: "100%", display: "flex", flexDirection: "column" }}>
              <NodeSlotGrid />
            </Paper>
          </Grid>
        </Grid>
      )}

      {tabValue === 1 && (
        <Grid container spacing={2} columns={12} alignItems="stretch">
          <Grid size={{ xs: 12, lg: 4 }}>
            <Paper elevation={2} sx={{ p: 2, height: "100%", display: "flex", flexDirection: "column" }}>
              <SlotConfigGrid
                onConfigSelect={handleConfigSelect}
                selectedConfig={selectedConfig}
                onSlotsChange={handleSlotsRefresh}
              />
            </Paper>
          </Grid>
          <Grid size={{ xs: 12, lg: 8 }}>
            <Paper elevation={2} sx={{ p: 2, height: "100%", display: "flex", flexDirection: "column" }}>
              <SlotGrid selectedConfig={selectedConfig} refreshTrigger={slotRefreshTrigger} />
            </Paper>
          </Grid>
        </Grid>
      )}

      {tabValue === 2 && (
        <Paper elevation={2} sx={{ p: 2, height: "100%" }}>
          <StockGrid />
        </Paper>
      )}
    </Box>
  );
}
